export default [
  {
    path: '/class-attendances-report-for-admins',
    name: 'class-attendances-report-for-admins',
    meta: { requiresAuth: true },
    component: () => import('./views/index.vue')
  }
]
